// A screen that is leaving (its exit animation is playing) must not re-render with the next phase's data, or the
// outgoing leaderboard briefly shows the podium's empty board. Each screen keeps the last snapshot that was its own.
import { useRef, useState } from 'react';
import type { StateSnapshot } from '@shared/types';
import { useGame } from '@/store/game';

export type SnapshotMatch = (s: StateSnapshot, mountedIndex: number | undefined) => boolean;

/** The live snapshot while it still belongs to this screen; the last one that did once the room has moved on. */
export function useOwnSnapshot(match: SnapshotMatch): StateSnapshot | undefined {
  const live = useGame((s) => s.snapshot);
  const [mountedIndex] = useState(() => useGame.getState().snapshot?.index);
  const last = useRef<StateSnapshot | undefined>(undefined);
  if (live && match(live, mountedIndex)) last.current = live;
  return last.current ?? live;
}

export const isLobby: SnapshotMatch = (s) => s.status === 'lobby';
export const isSameQuestion: SnapshotMatch = (s, i) => s.status === 'question' && s.index === i;
export const isSameReveal: SnapshotMatch = (s, i) => s.status === 'reveal' && s.index === i;
export const isFinish: SnapshotMatch = (s) => s.status === 'podium' || s.status === 'ended';
